import React, { useMemo } from 'react'
import { Button, Container, Table } from 'shared/components'
import useGiftConditionColumns from './useGiftConditionColumns'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { GIFT_CONDITIONS } from 'constans/queryKeys'
import { giftconditionApis } from 'api'
import * as urls from 'constans/urls'

const ConditionList = () => {
  const columns = useGiftConditionColumns()
  const navigate = useNavigate()
  const { data } = useQuery({
    queryKey: [GIFT_CONDITIONS],
    queryFn: () => giftconditionApis.getList(),
  })

  const sortData = useMemo(() => {
    return Array.isArray(data?.Result)
      ? data?.Result.sort((a, b) =>
          new Date(a.CreatedDate) > new Date(b.CreatedDate) ? -1 : 0
        )
      : []
  }, [data])

  const onCreateButtonClick = () =>
    navigate(`/${urls.GIFT_CONDITION_URLS.CREATE}`)
  return (
    <Container title="Điều kiện nhận quà">
      <Table
        heading="Danh sách điều kiện"
        data={sortData || []}
        columns={columns}
        additionalComponent={
          <Button width={100} onClick={onCreateButtonClick} color="success">
            Tạo mới
          </Button>
        }
      />
    </Container>
  )
}

export default ConditionList
